import React from 'react';

import styles from './BriefingItemChart.module.scss';

// palette-bg / itemChartNeutralDot are descendant-selector-driven (see
// _palettes.scss), so the palette-index class has to wrap a plain inner
// element rather than combine with it on one node. An overall reference
// line is a real SVG stroke so it can reuse palette-stroke and the same
// dash class as the plot. Only a "teams" chart's own team lines (no
// paletteClassName -- see isNeutral) fall back to a plain grey dot.
export default function LegendSwatch({
  dashed,
  paletteClassName,
  dotClassName,
}) {
  if (!paletteClassName) {
    return (
      <span
        className={`${styles.itemChartSwatch} ${styles.itemChartNeutralDot} ${dotClassName}`}
      />
    );
  }
  if (dashed) {
    return (
      <span className={`${styles.itemChartSwatch} ${paletteClassName}`}>
        <svg
          className={styles.itemChartLegendLine}
          width="24"
          height="8"
          viewBox="0 0 24 8"
          aria-hidden="true"
        >
          <line
            x1="0"
            x2="24"
            y1="4"
            y2="4"
            className={`palette-stroke ${styles.itemChartOverallLine}`}
          />
        </svg>
      </span>
    );
  }
  return (
    <span className={`${styles.itemChartSwatch} ${paletteClassName}`}>
      <span className={`palette-bg ${dotClassName}`} />
    </span>
  );
}
